import { colors, screen } from 'components/styles/variables';

interface LoadingFavoriteCardProps {
  className?: string;
}

const LoadingFavoriteCard = ({ className }: LoadingFavoriteCardProps): JSX.Element => {
  return (
    <div className={`loading-card ${className}`} data-testid="loading-card">
      <div className="gray-image shimmer" />
      <div className="info-container">
        <div className="flex-container">
          <div className="title shimmer" />
          <div className="price shimmer" />
        </div>
        <div className="flex-container secondary-info">
          <div className="mileage shimmer" />
          <div className="monthly-payment shimmer" />
        </div>
        <div className="location shimmer" />
        <div className="additional shimmer" />
      </div>
      <style jsx>{`
        .loading-card {
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 12px 12px 35px 12px;
          background-color: white;
          border-radius: 8px;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .loading-card {
            flex-direction: row;
            width: 770px;
            padding: 12px 16px 12px 12px;
          }
        }

        .shimmer {
          border-radius: 4px;
          background: linear-gradient(90deg, ${colors.G2} 0%, ${colors.G1} 40%, ${colors.G2} 60%);
          background-position: 0px 0px;
          background-size: 900% 900%;
          animation: BarAnimation 1.2s ease infinite;
        }

        .gray-image {
          width: 100%;
          height: 0;
          padding-top: 60.294%;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .gray-image {
            width: 272px;
            height: 164px;
            padding: 0;
            margin-right: 24px;
          }
        }

        .info-container {
          padding-top: 19px;
          flex-grow: 1;
        }

        .flex-container {
          display: flex;
          justify-content: space-between;
        }

        .title {
          width: 220px;
          height: 16px;
          margin-bottom: 16px;
        }

        .price {
          width: 54px;
          height: 16px;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .price {
            width: 98px;
            height: 16px;
          }
        }

        .mileage {
          width: 176px;
          height: 16px;
          margin-bottom: 16px;
        }

        .monthly-payment {
          width: 52px;
          height: 16px;
          margin-bottom: 16px;
        }

        .location {
          display: none;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .location {
            display: block;
            width: 220px;
            height: 16px;
            margin-bottom: 16px;
          }
        }

        .additional {
          width: 176px;
          height: 16px;
          margin-bottom: 16px;
        }

        @keyframes BarAnimation {
          0% {
            background-position: 100% 100%;
          }
          100% {
            background-position: 0% 0%;
          }
        }

        .secondary-info {
          display: none;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .secondary-info {
            display: flex;
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingFavoriteCard;
